import { render, staticRenderFns } from "./InitPage.vue?vue&type=template&id=325a923c"
import script from "./InitPage.vue?vue&type=script&lang=js"
export * from "./InitPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports